// extracted by mini-css-extract-plugin
export default {"settingsWrapper":"Settings_settingsWrapper__FOLiH","settingsNav":"Settings_settingsNav__L2orT","navLink":"Settings_navLink__KaM63","navLinkActive":"Settings_navLinkActive__hvnDd"};